import Title from './Title';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import DropDownMenu from './DropDownMenu';
import CheckOutsideRefWrapper from '../wrappers/CheckOutsideRefWrapper';
import "./Header.css";
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';

export default function Header(props) {
    const { title } = props;

    const profilePicture = useSelector((state) => state.settings?.file_profilePicture);

    const [ isOpenAccountMenu, setIsOpenAccountMenu ] = useState(false);

    return (
        <div className='header'>
            <Title title={title} />
            
            <CheckOutsideRefWrapper
                children={(
                    <>
                        {(profilePicture && typeof profilePicture === "string") ? (
                            <img src={profilePicture} onClick={() => setIsOpenAccountMenu(!isOpenAccountMenu)} alt="Profile" className='header-profile-picture' />
                        ) : (
                            <PersonOutlineOutlinedIcon onClick={() => setIsOpenAccountMenu(!isOpenAccountMenu)} className='header-icon' />
                        )}
                        <DropDownMenu
                            items={[
                                { name: "Settings", href: "/profile/information" },
                                { name: "Logout", href: "#", onClick: () => {
                                    Cookies.remove('apiKey');
                                    Cookies.remove('appUrl');
                                    Cookies.remove('email');
                                    Cookies.remove('isLoggedIn');
                                    window.location.href = window.location.href;
                                }}
                            ]}
                            isOpen={isOpenAccountMenu}
                            sx={{
                                right: 0,
                                top: 60
                            }}
                        />
                    </>
                )}
                func={() => setIsOpenAccountMenu(false)}
            />
        </div>
    )
}

Header.propTypes = {
    title: PropTypes.string
};